import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


const __default__ = {
    name: "ClientInfoRefererTooltip"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: {},
    value: {}
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", null, _toDisplayString(__props.label) + ":", 1),
    _createElementVNode("p", null, _toDisplayString(__props.value), 1)
  ], 64))
}
}

})